import { Injectable } from '@angular/core';
import { BaseService } from '@core/service/base.service';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, Subject } from 'rxjs/index';
import { catchError, tap } from 'rxjs/operators';

export const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
};

@Injectable({
  providedIn: 'root',
})
export class SupplierViewService extends BaseService {
  constructor(http: HttpClient) {
    super(http);
  }

  private url = 'api/supplier/get-module';

  private inputUrl = 'api/supplier/field-required';
  private saveUrl = 'api/supplier/save-module';
  private qualUrl = 'api/sup-qual/get-qual-by-supplier';
  private qualDetailUrl = 'api/qual-detail';
  private getBackUrl = 'api/supplier/get-back';
  private historyUrl = 'api/supHistory';
  private historyDetailUrl = 'api/supHistory/get-history';

  private getHisNum = 'api/supHistory/get-history-num';
  private getHisData = 'api/supHistory/get-history-data';

  private isSupplierUrl = 'api/supplier/is-supplier';
  private returnBackUrl = 'api/supplier/return-back';
  private confirmUrl = 'api/supplier/confirm';
  private createUrl = 'api/supplier/create-by-inner';
  private bankAttrUrl = 'api/dict-tables/search-with-list?dictCode=bankAccAttr';

  private supplierUrl = 'api/supplier';

  private dynamicUrl = 'api/supplier/get-dynamic-form';
  private currentSupplier = 'api/supplier/current-sample';
  private getAllModuleUrl = 'api/supplier/get-module-all-module';
  private getAllFunction = 'api/supplier/all-function-info';

  private getModifyurl = 'api/sup-modify';

  /*提交*/
  submitChange = new Subject<any>();
  /*暂存*/
  stagChange = new Subject<any>();

  getUrl(): string {
    return this.url;
  }

  //获取当前登陆供应商信息
  getSupplierId(): Observable<any> {
    return this.http.get<any>(this.currentSupplier).pipe(
      tap(_ => this.log(`getSupplierId`)),
      catchError(this.handleError<any>(`getSupplierId`)),
    );
  }

  //  获取历史版本详情
  getHistoryNum(params): Observable<any> {
    return this.http.get(this.getHisNum,
      {
        headers: httpOptions.headers,
        params: params,
      }
    ).pipe(
      tap(() => this.log('getHistoryNum')),
      catchError(this.handleError('getHistoryNum'))
    );
  }

  //  获取历史版本数据
  getHistoryData(params): Observable<any> {
    return this.http.get(this.getHisData,
      {
        headers: httpOptions.headers,
        params: params,
      }
    ).pipe(
      tap(() => this.log('getHistoryData')),
      catchError(this.handleError('getHistoryData')),
    );
  }

  //获取供应商信息
  getSupplier(id: number): Observable<any> {
    const url = `${this.supplierUrl}/${id}`;
    return this.http.get<any>(url).pipe(
      tap(_ => this.log(`getSupplier id=${id}`)),
      catchError(this.handleError<any>(`getSupplier id=${id}`)),
    );
  }

  //获取供应商审批信息
  getSupplierModify(id: number): Observable<any> {
    const url = `${this.getModifyurl}/${id}`;
    return this.http.get<any>(url).pipe(
      tap(_ => this.log(`getSupplier id=${id}`)),
      catchError(this.handleError<any>(`getSupplier id=${id}`)),
    );
  }

  //获取模块信息
  getModule(params): Observable<any> {
    return this.http.get(this.getUrl(),
      {
        headers: httpOptions.headers,
        params: params,
      },
    ).pipe(
      tap(() => this.log('getModule')),
      catchError(this.handleError('getModule'))
    );
  }

  //获取模块信息
  getFunctionList(params): Observable<any> {
    return this.http.get(this.getAllFunction,
      {
        headers: httpOptions.headers,
        params: params,
      },
    ).pipe(
      tap(() => this.log('getFunctionList')),
      catchError(this.handleError('getFunctionList')),
    );
  }

//  保存模块信息
  saveModule(object: any): Observable<any> {
    return this.http.post<any>(this.saveUrl, object, httpOptions).pipe(
      tap((object: any) => this.log(`saveModule`)),
      catchError(this.handleError<any>('saveModule')),
    );
  }

  //  保存管理信息模块信息
  saveManageInfo(object: any): Observable<any> {
    return this.http.post<any>('api/supplier/save-module-useSRmFun', object, httpOptions).pipe(
      tap((object: any) => this.log(`saveModuleuseSRmFun`)),
      catchError(this.handleError<any>('saveModuleuseSRmFun')),
    );
  }

//  获取资质模块
  getQualList(params): Observable<any> {
    return this.http.get(this.qualUrl,
      {
        headers: httpOptions.headers,
        params: params,
      },
    ).pipe(
      tap(() => this.log('getQualFieldRequired')),
      catchError(this.handleError('getQualFieldRequired')),
    );
  }

//  获取资质模块详情
  getQualDetail(id): Observable<any> {
    const url = `${this.qualDetailUrl}/${id}`;
    return this.http.get<any>(url).pipe(
      tap(_ => this.log(`getQualFieldRequired id=${id}`)),
      catchError(this.handleError<any>(`getQualFieldRequired id=${id}`)),
    );
  }

//  信息撤回
  getBack(params): Observable<any> {
    return this.http.post<any>(this.getBackUrl, params, httpOptions).pipe(
      tap((object: any) => this.log(`getBack`)),
      catchError(this.handleError<any>('getBack')),
    );
  }

//  获取历史版本列表
  getHistoryList(params: HttpParams): Observable<any> {
    return this.http.get(this.historyUrl,
      {
        headers: httpOptions.headers,
        observe: 'response',//完整数据返回，包括抬头
        params: params,
      },
    ).pipe(
      tap(() => this.log('query object')),
      catchError(this.handleError('get any', [])),
    );
  }

//  获取历史版本详情
  getHistoryDetail(params): Observable<any> {
    return this.http.get(this.historyDetailUrl,
      {
        headers: httpOptions.headers,
        params: params,
      },
    ).pipe(
      tap(() => this.log('getHistoryDetail')),
      catchError(this.handleError('getHistoryDetail')),
    );
  }

//  获取登陆用户信息，判断登陆用户是否为供应商
  isSupplier(): Observable<any> {
    return this.http.get(this.isSupplierUrl).pipe(
      tap(() => this.log('isSuppliers')),
      catchError(this.handleError('isSuppliers')),
    );
  }

//  管理员退回供应商提交的资料
  returnBack(params): Observable<any> {
    return this.http.post<any>(this.returnBackUrl, params, httpOptions).pipe(
      tap((object: any) => this.log(`returnBack`)),
      catchError(this.handleError<any>('returnBack')),
    );
  }

//  管理员确认供应商资料
  confirmSupplier(params): Observable<any> {
    return this.http.post<any>(this.confirmUrl, params, httpOptions).pipe(
      tap((object: any) => this.log(`confirmSupplier`)),
      catchError(this.handleError<any>('confirmSupplier')),
    );
  }

//  创建供应商
  createSupplier(params): Observable<any> {
    return this.http.post<any>(this.createUrl, params, httpOptions).pipe(
      tap((object: any) => this.log(`createSupplier`)),
      catchError(this.handleError<any>('createSupplier')),
    );
  }

//  获取银行属性列表
  getBankAttr(): Observable<any> {
    return this.http.get(this.bankAttrUrl,
      {
        headers: httpOptions.headers,
      },
    ).pipe(
      tap(() => this.log('getBankAttr')),
      catchError(this.handleError('getBankAttr')),
    );
  }

//  获取自定义表单code值
  getDynamicCode(params): Observable<any> {
    return this.http.get(this.dynamicUrl,
      {
        headers: httpOptions.headers,
        params: params,
      },
    ).pipe(
      tap(() => this.log('getDynamicCode')),
      catchError(this.handleError('getDynamicCode')),
    );
  }

  //  获取模块全部数据
  getAllModule(id): Observable<any> {
    return this.http.get(this.getAllModuleUrl,
      {
        headers: httpOptions.headers,
        params: id,
      },
    ).pipe(
      tap(() => this.log('getAllModule')),
      catchError(this.handleError('getAllModule')),
    );
  }
}
